import { Helmet } from "react-helmet";

const SEO = ({
  title = "Aaron Hunt Portfolio",
  description = "Whether you're building a game, a product, or something in between, I’m here to help.",
  image = "https://www.aaronhunt.dev/blog/i/pg.jpg",
  url = "https://aaronhunt.dev/",
  author = "Aaron Hunt",
  siteName = "aaronhunt.dev",
  twitterHandle = "@aaronh3d",
  publishedDate = "2025-06-10",
  logo = "https://www.aaronhunt.dev/logo192.png",
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:creator" content={twitterHandle} />

      <meta name="robots" content="index, follow" />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          mainEntityOfPage: url,
          headline: title,
          image: [image],
          author: {
            "@type": "Person",
            name: author,
          },
          publisher: {
            "@type": "Organization",
            name: siteName,
            logo: {
              "@type": "ImageObject",
              url: logo,
            },
          },
          url,
          description,
          datePublished: publishedDate,
          dateModified: publishedDate,
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
